import { render, staticRenderFns } from "./RegularGrades.vue?vue&type=template&id=1d3e659e&scoped=true&"
import script from "./RegularGrades.vue?vue&type=script&lang=js&"
export * from "./RegularGrades.vue?vue&type=script&lang=js&"
import style0 from "./RegularGrades.vue?vue&type=style&index=0&id=1d3e659e&lang=less&scoped=true&"
import style1 from "./RegularGrades.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3e659e",
  null
  
)

export default component.exports